import React from 'react'
import Video from './Components/Video'

const InteractiveVideo = ({ videoSrc, videoType, markers, number, muiTheme }) => {
  const playerRef = React.useRef(null)
  const markerStartLookup = React.useRef(Object.fromEntries(markers.map((marker, i) => [marker.markerStart, marker])));
  const markerEndLookup = React.useRef(
    Object.fromEntries(
      markers
        .filter(marker => !!marker.markerEnd)
        .map((marker, i) => [marker.markerEnd, marker])
    )
  );
  const videoJsOptions = {
    // lookup the options in the docs for more options
    controls: true,
    responsive: true,
    fluid: true,
    sources: [
      {
        src: videoSrc,
        type: videoType
      }
    ]
  }

  const handlePlayerReady = player => {
    playerRef.current = player
    let startCounter = 0
    let endCounter = 0
    var previousTime = 0;
    var currentTime = 0;
    var seekStart = null;
    let markerSeen = [];
    //player.controlBar.progressControl.disable();

    document.addEventListener('markerShow', e => {
      const marker = e.detail.marker
      if (markerSeen.includes(marker.name)) {
        return;
      }
      const player = e.detail.player
      if (e.detail.counter !== 0) return;
      console.log("Showing", marker.name)
      let component
      player.removeChild('vjsFullContainer')
      if (marker.pause) {
        player.pause()
      }
      if (marker.component) {
        if (marker.component.props.onFinish) {
          const _onFinish = marker.component.props.onFinish
          component = React.cloneElement(marker.component, {
            onFinish: (score) => {
              const result = _onFinish(score)
              player.play()
              player.controlBar.playToggle.enable();
              player.removeChild('vjsFullContainer')
              return result
            }
          })
        } else {
          component = React.cloneElement(marker.component)
        }
        player.controlBar.playToggle.disable();
        player.player_.handleTechClick_ = function () {};
        player.addChild('vjsFullContainer', {
          name: marker.name,
          body: component,
          theme: muiTheme,
        })
        markerSeen.push(marker.name);
      }
    });

    document.addEventListener('markerHide', e => {
      const player = e.detail.player
      if (e.detail.counter !== 0) return
      player.removeChild('vjsFullContainer')
      player.controlBar.playToggle.enable();
      player.play()
    });

    player.on(player, 'loadedmetadata', () => {
      let videoParent = document.getElementsByClassName("vjs-progress-control vjs-control")[number];
      const duration = player.duration()
      Object.keys(markerStartLookup.current).forEach((markerTime, index) => {
        let elem = document.createElement("div");
        elem.id = "marker" + index;
        elem.style.position = 'absolute'
        elem.style.height = '50%'
        elem.style.width = '4px'
        elem.style.cursor = 'pointer'
        elem.style.backgroundColor = '#ED1A3B'
        elem.style.opacity = 1
        elem.style.left = markerTime / duration * 100 + "%";
        elem.addEventListener("click", function (event) {
          if (player.currentTime() > markerTime) {
            player.currentTime(markerTime);
            player.removeChild('vjsFullContainer')
            player.controlBar.playToggle.enable();
            player.play()
          }
        });
        videoParent.appendChild(elem);
      })
    })

    player.on(player, 'timeupdate', () => {
      previousTime = currentTime;
      currentTime = player.currentTime();
      const markerStartTime = Object.keys(markerStartLookup.current).find((time, index) => {
        if (currentTime > parseFloat(time) && currentTime < parseFloat(time) + .75) {
          return time;
        } else return null;
      });
      const markerEndTime = Object.keys(markerEndLookup.current).find((time, index) => {
        if (currentTime > parseFloat(time) && currentTime < parseFloat(time) + .5) {
          return time;
        } else return null;
      });
      if (!!markerStartTime) {
        const event = new CustomEvent('markerShow', {
          detail: {
            marker: markerStartLookup.current[markerStartTime],
            player,
            counter: startCounter
          }
        })
        document.dispatchEvent(event)
        startCounter++
      }
      if (startCounter >= 4) {
        startCounter = 0;
      }
      if (!!markerEndTime) {
        const event = new CustomEvent('markerHide', {
          detail: {
            marker: markerEndLookup.current[markerEndTime],
            player,
            counter: endCounter
          }
        })
        document.dispatchEvent(event)
        endCounter++
      }
      if (endCounter >= 4) {
        endCounter = 0;
      }
    })

    player.on('seeking', function () {
      if (seekStart === null) {
        seekStart = previousTime;
      }
    })

    player.on('seeked', function () {
      if (currentTime > seekStart) {
         player.currentTime(seekStart);
      }
      seekStart = null;
      player.removeChild('vjsFullContainer');
      player.controlBar.playToggle.enable();
      player.play()
      markerSeen = [];
    });
  }

  return <Video options={videoJsOptions} onReady={handlePlayerReady} />
}

export default InteractiveVideo
